/**
 * axios 实例
 */
import axios from 'axios'
import router from '@/router'
import { MessageBox } from 'element-ui'
import { API_BASE_URL, TOKEN_HEADER_NAME, LAYOUT_PATH } from '@/config/setting'
import { getToken, setToken } from './token-util'
import { logout } from './page-tab-util'
import qs from 'qs'

const service = axios.create({
  baseURL: API_BASE_URL,
  // 设置请求头
  headers: {
    'Content-Type': 'application/json'
  }
})

/**
 * 添加请求拦截器
 */
service.interceptors.request.use(
  (config) => {

    let platform = navigator.platform.toLowerCase()
    let isWindows = platform.includes('win')
    let isLinux = platform.includes('linux')
    platform = 'web'
    if (isWindows) {
      platform = 'windows'
    } else if (isLinux) {
      platform = 'linux'
    }

    config.headers.platform = platform
    config.headers.osName = 'web'

    if ('requestBaseUrl' in config) {
      config.baseURL = window.appConfig[config.requestBaseUrl]
    } else {
      config.baseURL = window.appConfig.VUE_APP_API_BASE_URL
    }
    if (config.headers['Content-Type'].indexOf('application/json') > -1) {
      config.data = JSON.stringify(config.data)
    } else {
      if (config.method === 'post' && config.headers['Content-Type'].indexOf('multipart/form-data') === -1) {
        let data = qs.parse(config.data)
        config.data = qs.stringify({ ...data })
      } else if (config.method === 'get') {
        config.params = { ...config.params }
      }
    }

    // 添加 token 到 header
    const token = getToken()
    if (token && config.headers) {
      config.headers.common[TOKEN_HEADER_NAME] = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

/**
 * 添加响应拦截器
 */
service.interceptors.response.use(
  (res) => {
    // 登录过期处理
    if (res.data?.code === 401) {
      const currentPath = router.currentRoute.path
      if (currentPath === LAYOUT_PATH) {
        logout(true)
      } else {
        MessageBox.alert('登录状态已过期, 请退出重新登录!', '系统提示', {
          confirmButtonText: '重新登录',
          callback: (action) => {
            if (action === 'confirm') {
              logout(false, currentPath)
            }
          },
          beforeClose: () => {
            MessageBox.close()
          }
        })
      }
      return Promise.reject(new Error(res.data.message))
    }
    // token 自动续期
    const token = res.headers[TOKEN_HEADER_NAME.toLowerCase()]
    if (token) {
      setToken(token)
    }
    return res
  },
  (error) => {
    return Promise.reject(error)
  }
)

let http = {
  post (url, data, options) {
    return new Promise((resolve, reject) => {
      // service.post(url, params, options)
      service({
        method: 'post',
        url,
        data,
        ...options
      })
        .then(response => {
          resolve(response)
        }, err => {
          reject(err)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  get (url, params, options) {
    return new Promise((resolve, reject) => {
      // service.get(url, { params })
      service({
        method: 'get',
        url,
        params,
        ...options
      })
        .then(response => {
          resolve(response)
        }, err => {
          reject(err)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  put (url, data, options) {
    return new Promise((resolve, reject) => {
      // service.put(url, params)
      service({
        method: 'put',
        url,
        data,
        ...options
      })
        .then(response => {
          resolve(response)
        }, err => {
          reject(err)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  delete (url, params, options) {
    return new Promise((resolve, reject) => {
      // service.delete(url, { params })
      service({
        method: 'delete',
        url,
        params,
        ...options
      })
        .then(response => {
          resolve(response)
        }, err => {
          reject(err)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
export default http
